export default {
  data () {
    return {
      results: [],
      loading: false
    }
  },
  methods: {
    async doSearch (withDeleted = true, successCallback = () => {}, errorCallback = () => {}) {
      this.loading = true
      const { status, payload } = await this.$get('v1/appointments/types/available', {
        with_deleted: withDeleted
      })
      this.loading = false
      if (status === 'success') {
        this.results = payload.types
        successCallback()
      }
      else {
        errorCallback()
      }
    },
    baseSearchFilter (val) {
      const filter = val.toLowerCase()
      return this.results.filter(item =>
        (item.shorthand_name || '').toLowerCase().includes(filter) ||
        (item.name || '').toLowerCase().includes(filter)
      )
    }
  }
}
